module.exports = __webpack_public_path__ + "media/images/recruit/section/mv_department_sp07-f9dd0ecec38a56cfcdf1bb81aba8fc58.jpg";